import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../../contexts/auth";
import { OnboardingWrapper } from "./styles";

const OnboardingLayout = (props: any) => {
  let auth: any = useContext(AuthContext);
  let location = useLocation();

  if (auth?.user) {
    return <Navigate to="/dashboard" state={{ from: location }} replace />;
  }

  return (
    <OnboardingWrapper>
      <Outlet />
    </OnboardingWrapper>
  );
};

export default OnboardingLayout;
